import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const GetQueryLogs: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleSilentCall = async () => {
      const tenant = searchParams.get("tenant");
      const key = searchParams.get("key");

      const params = {
        key: key,
      };

      try {
        const response = await axios.post(
          "/snotes/api/querySwitch/getLogs",
          params,
          {
            headers: {
              "X-TENANT-ID": tenant,
            },
          }
        );

        const jsonData = JSON.stringify(response.data, null, 2);
        const textData: string[] = JSON.parse(jsonData);
        if (textData.length < 1) return;

        const blob = new Blob([textData.join("\n\n")], {
          type: "text/plain;charset=utf-8",
        });

        const element = document.createElement("a");
        element.href = URL.createObjectURL(blob);
        element.download = `sql-response-${Date.now()}.txt`; // 파일명 설정

        // 4. 가상 태그를 클릭하여 다운로드 트리거 후 제거
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } catch (error) {
      } finally {
        setTimeout(() => {
          window.close();
        }, 500);
      }
    };

    handleSilentCall();
  }, [searchParams]);

  return null;
};

export default GetQueryLogs;
